import {
  Home,
  Menu,
  X,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUp,
  ChevronsDown,
  MoreHorizontal,
  MoreVertical,
  User,
  Users,
  Users2,
  UserPlus,
  UserMinus,
  UserCheck,
  UserX,
  UserCog,
  UserCircle,
  UserSquare,
  Mail,
  MessageCircle,
  MessageSquare,
  Send,
  Phone,
  Bell,
  BellOff,
  File,
  FileText,
  Files,
  Folder,
  FolderOpen,
  FilePlus,
  Download,
  Upload,
  Image,
  Film,
  Video,
  Camera,
  Music,
  Play,
  Pause,
  Volume2,
  ShoppingCart,
  ShoppingBag,
  CreditCard,
  Wallet,
  DollarSign,
  Euro,
  Tag,
  Tags,
  Gift,
  Ticket,
  BadgeCheck,
  BadgeDollarSign,
  MapPin,
  Map,
  Navigation,
  Compass,
  Globe,
  Calendar,
  Clock,
  Timer,
  AlarmClock,
  Check,
  CheckCircle,
  CheckCircle2,
  AlertCircle,
  AlertTriangle,
  Info,
  XCircle,
  HelpCircle,
  Share,
  Share2,
  Heart,
  HeartHandshake,
  HeartPulse,
  HeartCrack,
  HeartOff,
  HandHeart,
  Handshake,
  Star,
  ThumbsUp,
  ThumbsDown,
  Laugh,
  PartyPopper,
  Lock,
  Unlock,
  Key,
  Shield,
  ShieldCheck,
  Eye,
  EyeOff,
  Link,
  Link2,
  ExternalLink,
  Paperclip,
  Edit,
  Edit2,
  Edit3,
  Pencil,
  Trash,
  Trash2,
  Copy,
  Scissors,
  Settings,
  Sliders,
  Filter,
  Search,
  Maximize,
  Minimize,
  Plus,
  PlusCircle,
  Minus,
  MinusCircle,
  Building,
  Building2,
  Store,
  Warehouse,
  Book,
  BookOpen,
  Bookmark,
  Award,
  Trophy,
  Target,
  Flag,
  Briefcase,
  Package,
  GraduationCap,
  BookMarked,
  Library,
  Zap,
  Sparkles,
  Flame,
  Loader,
  RefreshCw,
  BarChart,
  BarChart2,
  BarChart3,
  LineChart,
  PieChart,
  TrendingUp,
  TrendingDown,
  Layout,
  Grid,
  Columns,
  Rows,
  List,
  Layers,
  Sun,
  Moon,
  Cloud,
  CloudRain,
  Leaf,
  TreePine,
  Circle,
  Square,
  Triangle,
  Diamond,
  Hexagon,
  Octagon,
  Waves,
  Rainbow,
  Sparkle,
  Coffee,
  Pizza,
  Utensils,
  Smile,
  Frown,
  Meh,
  Palette,
  Paintbrush,
  type LucideIcon,
} from 'lucide-react'

/**
 * The icons a CMS link can show, keyed by the values of the `icon` select in
 * src/fields/link.ts. Imported by name rather than `import * as LucideIcons`, which pulled all
 * ~1,500 Lucide icons (about 470 KB of JavaScript) into the browser bundle of every page that
 * renders a Link.
 *
 * Kept in step with the select two ways: `LinkIconName` is checked against the generated Payload
 * type wherever a CMS link reaches <CMSLink>, and tests/unit/linkIcons.spec.ts compares the lists.
 */
export const LINK_ICONS = {
  Home,
  Menu,
  X,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUp,
  ChevronsDown,
  MoreHorizontal,
  MoreVertical,
  User,
  Users,
  Users2,
  UserPlus,
  UserMinus,
  UserCheck,
  UserX,
  UserCog,
  UserCircle,
  UserSquare,
  Mail,
  MessageCircle,
  MessageSquare,
  Send,
  Phone,
  Bell,
  BellOff,
  File,
  FileText,
  Files,
  Folder,
  FolderOpen,
  FilePlus,
  Download,
  Upload,
  Image,
  Film,
  Video,
  Camera,
  Music,
  Play,
  Pause,
  Volume2,
  ShoppingCart,
  ShoppingBag,
  CreditCard,
  Wallet,
  DollarSign,
  Euro,
  Tag,
  Tags,
  Gift,
  Ticket,
  BadgeCheck,
  BadgeDollarSign,
  MapPin,
  Map,
  Navigation,
  Compass,
  Globe,
  Calendar,
  Clock,
  Timer,
  AlarmClock,
  Check,
  CheckCircle,
  CheckCircle2,
  AlertCircle,
  AlertTriangle,
  Info,
  XCircle,
  HelpCircle,
  Share,
  Share2,
  Heart,
  HeartHandshake,
  HeartPulse,
  HeartCrack,
  HeartOff,
  HandHeart,
  Handshake,
  Star,
  ThumbsUp,
  ThumbsDown,
  Laugh,
  PartyPopper,
  Lock,
  Unlock,
  Key,
  Shield,
  ShieldCheck,
  Eye,
  EyeOff,
  Link,
  Link2,
  ExternalLink,
  Paperclip,
  Edit,
  Edit2,
  Edit3,
  Pencil,
  Trash,
  Trash2,
  Copy,
  Scissors,
  Settings,
  Sliders,
  Filter,
  Search,
  Maximize,
  Minimize,
  Plus,
  PlusCircle,
  Minus,
  MinusCircle,
  Building,
  Building2,
  Store,
  Warehouse,
  Book,
  BookOpen,
  Bookmark,
  Award,
  Trophy,
  Target,
  Flag,
  Briefcase,
  Package,
  GraduationCap,
  BookMarked,
  Library,
  Zap,
  Sparkles,
  Flame,
  Loader,
  RefreshCw,
  BarChart,
  BarChart2,
  BarChart3,
  LineChart,
  PieChart,
  TrendingUp,
  TrendingDown,
  Layout,
  Grid,
  Columns,
  Rows,
  List,
  Layers,
  Sun,
  Moon,
  Cloud,
  CloudRain,
  Leaf,
  TreePine,
  Circle,
  Square,
  Triangle,
  Diamond,
  Hexagon,
  Octagon,
  Waves,
  Rainbow,
  Sparkle,
  Coffee,
  Pizza,
  Utensils,
  Smile,
  Frown,
  Meh,
  Palette,
  Paintbrush,
} satisfies Record<string, LucideIcon>

export type LinkIconName = keyof typeof LINK_ICONS

/** Looks up an icon by a name that isn't known to be valid (e.g. a raw form value). */
export function getLinkIcon(name: string): LucideIcon | undefined {
  return Object.hasOwn(LINK_ICONS, name) ? LINK_ICONS[name as LinkIconName] : undefined
}
